import React from 'react';

const predefinedSizeGuides = {
  remera: {
    title: 'Guía de Talles - Prendas Superiores',
    firstColumnLabel: 'Talla',
    unit: 'cm',
    note: 'Todas las medidas están en centímetros. Tolerancia: ± 2.5 cm.',
    helpText: 'Ancho: medir de axila a axila con la prenda extendida.\nLargo: medir desde el hombro hasta el borde inferior.',
    columns: ['Ancho', 'Largo'],
    rows: [
      { label: 'S', values: ['45.7', '70.5'] },
      { label: 'M', values: ['50.8', '73.0'] },
      { label: 'L', values: ['55.9', '75.6'] },
      { label: 'XL', values: ['61.0', '78.1'] },
      { label: 'XXL', values: ['66.0', '80.6'] },
      { label: 'XXXL', values: ['71.1', '83.2'] }
    ]
  },
  buzo: {
    title: 'Guía de Talles - Buzos',
    firstColumnLabel: 'Talla',
    unit: 'cm',
    note: 'Todas las medidas están en centímetros. Tolerancia: ± 2.5 cm.',
    helpText: 'Ancho: medir de axila a axila con la prenda extendida.\nLargo: medir desde el hombro hasta el borde inferior.',
    columns: ['Ancho', 'Largo'],
    rows: [
      { label: 'S', values: ['50.8', '68.6'] },
      { label: 'M', values: ['55.9', '71.1'] },
      { label: 'L', values: ['61.0', '73.7'] },
      { label: 'XL', values: ['66.0', '76.2'] },
      { label: 'XXL', values: ['71.1', '78.7'] }
    ]
  },
  canguro: {
    title: 'Guía de Talles - Canguros',
    firstColumnLabel: 'Talla',
    unit: 'cm',
    note: 'Todas las medidas están en centímetros. Tolerancia: ± 2.5 cm.',
    helpText: 'Ancho: medir de axila a axila con la prenda extendida.\nLargo: medir desde el hombro hasta el borde inferior.',
    columns: ['Ancho', 'Largo'],
    rows: [
      { label: 'S', values: ['50.8', '68.6'] },
      { label: 'M', values: ['55.9', '71.1'] },
      { label: 'L', values: ['61.0', '73.7'] },
      { label: 'XL', values: ['66.0', '76.2'] },
      { label: 'XXL', values: ['71.1', '78.7'] }
    ]
  }
};

const normalizeGuide = (guide) => {
  if (!guide || typeof guide !== 'object') {
    return null;
  }

  const columns = Array.isArray(guide.columns)
    ? guide.columns.map((column) => column?.trim()).filter(Boolean)
    : [];

  const rows = Array.isArray(guide.rows)
    ? guide.rows
      .map((row) => ({
        label: row?.label?.trim() || '',
        values: columns.map((_, index) => row?.values?.[index]?.trim?.() || row?.values?.[index] || '')
      }))
      .filter((row) => row.label || row.values.some(Boolean))
    : [];

  if (!columns.length || !rows.length) {
    return null;
  }

  return {
    title: guide.title?.trim() || 'Tabla de Medidas',
    firstColumnLabel: guide.firstColumnLabel?.trim() || 'Talla',
    unit: guide.unit?.trim() || 'cm',
    note: guide.note?.trim() || '',
    helpText: guide.helpText?.trim() || '',
    columns,
    rows
  };
};

const shouldAppendUnit = (value) => /^\d+([.,]\d+)?$/.test(String(value).trim());

const SizeGuideModal = ({ isOpen, onClose, productType = 'remera', customGuide = null }) => {
  if (!isOpen) {
    return null;
  }

  const guide = normalizeGuide(customGuide) || predefinedSizeGuides[productType] || predefinedSizeGuides.remera;
  const helpLines = guide.helpText
    ? guide.helpText.split('\n').map((line) => line.trim()).filter(Boolean)
    : [];

  return (
    <div className="size-guide-overlay" onClick={onClose}>
      <div className="size-guide-modal" onClick={(event) => event.stopPropagation()}>
        <button className="size-guide-close" onClick={onClose}>
          <i className="fa-solid fa-times"></i>
        </button>

        <div className="size-guide-header">
          <i className="fa-solid fa-ruler"></i>
          <h3>{guide.title}</h3>
        </div>

        <div className="size-guide-body">
          <p className="size-guide-note">
            <i className="fa-solid fa-info-circle"></i>
            {guide.note || `Todas las medidas están expresadas en ${guide.unit}.`}
          </p>

          <div className="size-guide-table-wrapper">
            <table className="size-guide-table">
              <thead>
                <tr>
                  <th>{guide.firstColumnLabel}</th>
                  {guide.columns.map((column, index) => (
                    <th key={`${column}-${index}`}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {guide.rows.map((row, rowIndex) => (
                  <tr key={`${row.label}-${rowIndex}`}>
                    <td className="talla-cell">{row.label}</td>
                    {guide.columns.map((column, index) => (
                      <td key={`${row.label}-${column}-${index}`}>
                        {row.values[index]}
                        {shouldAppendUnit(row.values[index]) ? ` ${guide.unit}` : ''}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {helpLines.length > 0 && (
            <div className="size-guide-help">
              <p className="size-guide-help-title"><strong>¿Cómo medir?</strong></p>
              {helpLines.map((line) => (
                <p key={line}>{line}</p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SizeGuideModal;
